import { render, staticRenderFns } from "./CategorySortShowInHome.vue?vue&type=template&id=5fb5d770&"
import script from "./CategorySortShowInHome.vue?vue&type=script&lang=js&"
export * from "./CategorySortShowInHome.vue?vue&type=script&lang=js&"
import style0 from "@@/core/pages/category/Category/CategoryStylePublic.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports